var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin-still-alive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin-still-alive"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.1109181 C0,14.172658 2.42226422,17.9772818 4.75863254,20.8125084 C7.09500086,23.6477349 9.43136918,25.5378859 9.43136918,25.5378859 L10.0017179,26 L10.5720667,25.5378859 C10.5720667,25.5378859 12.908435,23.6477349 15.2448033,20.8125084 C17.5811716,17.9772818 20,14.172658 20,10.1109181 C20,4.53775224 15.5127985,0 10.0017179,0 C4.49063735,0 0,4.53775224 0,10.1109181 Z",
    id: "Fill-1-Copy-3",
    fill: "#F5A623"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_pause_2321507-copy",
    transform: "translate(6.000000, 6.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.888888889,0 C0.397968889,0 0,0.358172 0,0.8 L0,7.2 C0,7.641828 0.397968889,8 0.888888889,8 L2.66666667,8 C3.15758667,8 3.55555556,7.641828 3.55555556,7.2 L3.55555556,0.8 C3.55555556,0.358172 3.15758667,0 2.66666667,0 L0.888888889,0 Z M5.33333333,0 C4.84241333,0 4.44444444,0.358172 4.44444444,0.8 L4.44444444,7.2 C4.44444444,7.641828 4.84241333,8 5.33333333,8 L7.11111111,8 C7.60203111,8 8,7.641828 8,7.2 L8,0.8 C8,0.358172 7.60203111,0 7.11111111,0 L5.33333333,0 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinPause);
export default __webpack_public_path__ + "static/media/pin-pause.1231ded9689f824b54e321a246bc318d.svg";
export { ForwardRef as ReactComponent };